import moment from 'moment'
import Vue from 'vue'
import { TokenService } from '@microbadevs/library'

const authService = {

  getUserID () {
    const token = this.getAccessToken()
    const decoded = Vue.$jwt.decode(token)
    return decoded.user_id
  },

  getHCPID () {
    const token = this.getAccessToken()
    const decoded = Vue.$jwt.decode(token)
    return decoded.hcp_id
  },

  getAccessToken () {
    return localStorage.getItem('access_token')
  },

  setAccessToken (token) {
    // console.log(token);
    localStorage.setItem('access_token', token)
  },

  setRefreshToken (token) {
    localStorage.setItem('refresh_token', token)
  },

  removeAccessToken () {
    localStorage.removeItem('access_token')
  },

  removeRefreshToken () {
    localStorage.removeItem('refresh_token')
  },

  getAccessTokenExpiration () {
    return localStorage.getItem('expire_in')
  },

  getRefreshToken () {
    return localStorage.getItem('refresh_token')
  },

  setAccessTokenExpiration (expiration) {
    const timestamp = moment().add(expiration, 's').unix()
    localStorage.setItem('expire_in', timestamp)
  },

  removeAccessTokenExpiration () {
    localStorage.removeItem('expire_in')
  },

  logout () {
    authService.removeAccessToken()
    authService.removeRefreshToken()
    authService.removeAccessTokenExpiration()
  },

  tokenHasExpired () {
    const expiry = authService.getAccessTokenExpiration()
    return expiry && moment().unix() > expiry
  },

  isLoggedIn () {
    return !!authService.getAccessToken()
  },

  setAuth (token, expiration) {
    authService.setAccessToken(token)
    authService.setAccessTokenExpiration(expiration)
  },
  getUserAuthorities () {
    const token = this.getAccessToken()
    const decoded = Vue.$jwt.decode(token)
    return decoded.authorities
  },

  canImpersonate () {
    return TokenService.canImpersonate()
  }
}

export default authService
